import React from 'react';
import Moment from 'react-moment';
import MomentCore from 'moment';
import PropTypes from 'prop-types';

import {
	makeStyles,
	Typography
} from '@material-ui/core';

import AuthorizedUser from "../utils/AuthorizedUser";
import Constants from '../utils/Constants';

const styles = makeStyles(theme => ({
	timestamp: {
		color: Constants.COLORS.SECONDARY.GREY,
		fontWeight: "bold",
		lineHeight: "20px",
	},

	timestampPrimary: {
		color: theme.palette.text.primary
	},

	reducedSize: {
		fontSize: "0.9rem"
	},

	reducedSize2: {
		fontSize: "0.8rem"
	},

	moreContrast: {
		color: theme.palette.accessibilityColors.text.secondary
	}
}));

function Timestamp(props) {
	const getMoment = () => {
		let {time, relative, format, overYearFormat} = props;

		if (!time) {
			return null;
		}

		// assuming all times are UTC
		let now = new MomentCore(),
			postTime = new MomentCore.utc(time).local(),
			within3days = postTime.isAfter(now.subtract(4, "days")),
			within1year = postTime.isAfter(now.subtract(1, "years"));

		// relative within 3 days
		if (within3days && relative !== false) {
			return (
				<Moment fromNow>{postTime}</Moment>
			);
		}

		// older than 1 year, relative not important and format showing year
		if (!within1year) {
			return (
				<Moment format={overYearFormat}>{postTime}</Moment>
			);
		}

		// Month Day, Year h:mma
		return (
			<Moment format={format}>{postTime}</Moment>
		);
	};

	let classes = styles(),
		{palette, className, reducedSize, reducedSize2} = props,
		colorClass = AuthorizedUser.wantsMoreContrast() ? classes.moreContrast : palette === "primary" ? classes.timestampPrimary : classes.timestamp;

	return (
		<Typography className={`${colorClass} ${reducedSize ? classes.reducedSize : ""} ${reducedSize2 ? classes.reducedSize2 : ""} ${className}`}>
			{getMoment()}
		</Typography>
	);
}

Timestamp.defaultProps = {
	relative: true,
	reducedSize: true,
	reducedSize2: false,
	format: "ddd MMM Do @ h:mma",
	overYearFormat: "MMM Do YYYY @ h:mma"
};

Timestamp.propTypes = {
	className: PropTypes.string,
	time: PropTypes.string,
	format: PropTypes.string,
	overYearFormat: PropTypes.string,
	palette: PropTypes.string,
	relative: PropTypes.bool, // default is true
	reducedSize: PropTypes.bool,
	reducedSize2: PropTypes.bool
};

export default Timestamp;
